import { render, staticRenderFns } from "./OtherActions.vue?vue&type=template&id=d1123948&scoped=true&"
import script from "./OtherActions.vue?vue&type=script&lang=js&"
export * from "./OtherActions.vue?vue&type=script&lang=js&"
import style0 from "./OtherActions.vue?vue&type=style&index=0&id=d1123948&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1123948",
  null
  
)

export default component.exports